module.exports = __webpack_public_path__ + "static/img/user_name.5fb7a777.png";